import React from 'react'
import { useTranslation } from 'react-i18next'
import classnames from 'classnames'

import SpreadSheet from '../../../../components/SpreadSheet'

import { URLS } from '../../UploadDV360AdCreative/UploadDV360AdCreativeForm/LineItemForm/fields'

import useDrawerFormStyles from '../../../../styles/common/drawerForms'
import useStyles from './styles'

const urlsSpreadSheetColumnLabels = ['Url', 'Exclude url']

const errorRowsIndexes = []

const UrlsSection = ({ formik }) => {
  const { t } = useTranslation()

  const classes = useStyles()
  const drawerFormClasses = useDrawerFormStyles()

  const { values, setFieldValue, errors, touched } = formik

  return (
    <section className={classnames(drawerFormClasses.section, classes.urlsSection)}>
      <h3 className={drawerFormClasses.sectionTitle}>{t('List of URLs to target')}</h3>
      <p>{t('You can paste the list from another spreadsheet and we will automatically add enough rows.')}</p>
      <SpreadSheet
        name={URLS}
        setFieldValue={setFieldValue}
        formikData={values[URLS]}
        columnLabels={urlsSpreadSheetColumnLabels}
        maxRows={500}
        className={classes.spreadSheet}
        tableClassName={classes.spreadSheetTable}
        error={touched[URLS] && errors[URLS]}
        errorRowsIndexes={errorRowsIndexes}
      />
    </section>
  )
}

export default UrlsSection
